import React, { useContext } from 'react'
import { Grid, Typography } from '@material-ui/core'
import { components } from 'cng-web-lib'
import { ACEOceanTranslationContext } from '../../contexts/ACEOceanTranslationContext'
import CngSection from 'src/components/cngcomponents/CngSection'
import { useWatch } from "react-hook-form"

const {
    form: {
        field: {
            CngTextField,
            CngCodeMasterAutocompleteField
        }
    },
    CngGridItem
} = components

function BillOfLadingGoodsDetailsSection(props) {
    const { disabled, shouldHideMap } = props
    const { getTranslatedText } = useContext(ACEOceanTranslationContext)

    const { totalValueUom,totalPackagesUom,totalGrossWeightUom} = useWatch()

    return (
        <Grid item xs={12} md={12}>
            <CngSection title={"Goods Information"}
                subheader={
                    <Typography color='textSecondary' variant='caption'>
                        <Typography variant='inherit' color='error'>*</Typography>
                        Mandatory fields
                    </Typography>
                }>

                <Grid container spacing={1}>
                    <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.totalPackages}>
                        <CngTextField
                            name='totalPackages'
                            label={getTranslatedText('BOL', 'totalPackages')}
                            disabled={disabled}
                            required
                            size='small'
                        />
                    </CngGridItem>
                    <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.totalPackagesUom}>
                        <CngCodeMasterAutocompleteField
                            name='totalPackagesUom'
                            label={getTranslatedText('BOL', 'totalPackagesUom')}
                            disabled={disabled}
                            codeType='BOL_PACKAGES_UOM'
                            lookupProps={{
                                label: (record) => `${record.code};${record.descriptionEn}`
                            }}
                            required
                            key={totalPackagesUom}
                            size='small'
                        />
                    </CngGridItem>
                    <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.totalGrossWeight}>
                        <CngTextField
                            name='totalGrossWeight'
                            label={getTranslatedText('BOL', 'totalGrossWeight')}
                            disabled={disabled}
                            required
                            size='small'
                        />
                    </CngGridItem>
                    <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.totalGrossWeightUom}>
                        <CngCodeMasterAutocompleteField
                            name='totalGrossWeightUom'
                            label={getTranslatedText('BOL', 'totalGrossWeightUom')}
                            disabled={disabled}
                            codeType='BOL_GOODS_GROSS_UOM'
                            required
                            size='small'
                            key={totalGrossWeightUom}
                        />
                    </CngGridItem>
                    <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.totalVolume}>
                        <CngTextField
                            name='totalVolume'
                            label={getTranslatedText('BOL', 'totalVolume')}
                            disabled={disabled}
                            size='small'
                        />
                    </CngGridItem>
                    <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.totalValueUom}>
                        <CngCodeMasterAutocompleteField
                            name='totalValueUom'
                            label={getTranslatedText('BOL', 'totalValueUom')}
                            disabled={disabled}
                            codeType='BOL_GOODS_VOLUME_UOM'
                            size='small'
                            key={totalValueUom}
                        />
                    </CngGridItem>
                </Grid>
            </CngSection>
        </Grid>
    )
}

export default BillOfLadingGoodsDetailsSection